import React from 'react';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import {ValueFormatter} from '@epic-visualizations/charts';

import {getLabel} from './utils';
import Trend from '../../../../../trend/Trend';
import {getDirectionStyles} from '../../../../../../utils/ThemeUtils';

import {KeysMap, Trends} from './types';

export const StyledTooltipContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: max-content;

    & > span {
        font-weight: bold;
    }
`;

export const StyledSpan = styled.span`
    margin: ${p =>
        getDirectionStyles(p.theme.muiTheme.direction)(
            p.theme.muiTheme.spacing(0, 1, 0, 0),
            p.theme.muiTheme.spacing(0, 0, 0, 1)
        )};
`;

export const StyledLegendMarker = styled.div`
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;

    margin: ${p =>
        getDirectionStyles(p.theme.muiTheme.direction)(
            p.theme.muiTheme.spacing(0, 2, 0, 0),
            p.theme.muiTheme.spacing(0, 0, 0, 2)
        )};
`;

export interface CustomTooltipParams {
    trends?: Trends;
    tooltipFormatter: ValueFormatter<string | number>;
    keysMap?: KeysMap;
}

const CustomTooltip = ({trends, tooltipFormatter, keysMap}: CustomTooltipParams) => {
    if (!trends) {
        return undefined;
    }

    return ({payload}: {payload: any}) => (
        <Box display="flex" flexDirection="column">
            {(payload || [])
                .sort(({value: a}, {value: b}) => b - a)
                .map(({name, value, color, payload}) => {
                    const trend = trends[payload.time.toString()][name];

                    return (
                        <StyledTooltipContainer key={name}>
                            <StyledLegendMarker
                                style={{backgroundColor: `${color || (payload as any).fill}`}}
                            />
                            <StyledSpan>{getLabel(name, keysMap)}:</StyledSpan>
                            <StyledSpan>
                                {tooltipFormatter ? tooltipFormatter(value) : Math.ceil(value)}
                            </StyledSpan>
                            <Box mx="8px">
                                <Trend value={trend} />
                            </Box>
                        </StyledTooltipContainer>
                    );
                })}
        </Box>
    );
};

export default CustomTooltip;
